export default __webpack_public_path__ + "2d7f2fe79c5bbe04939ee83e902e13a9.png";